<template>
  <div :class="{ 'weui-search-bar': true, 'weui-search-bar_focusing': searching }">
    <form class="weui-search-bar__form">
      <div class="weui-search-bar__box">
        <i class="weui-icon-search" />
        <input type="search" class="weui-search-bar__input" placeholder="搜索" ref="input" :value="value" @input="updateValue($event.target.value)">
        <a href="javascript:" class="weui-icon-clear" @click="clearInput" />
      </div>
      <label v-show="!searching" class="weui-search-bar__label" style="transform-origin: 0 0 0; opacity: 1; transform: scale(1, 1);" @click="focusInput">
        <i class="weui-icon-search" />
        <span>{{ placeholder }}</span>
      </label>
    </form>
    <a href="javascript:" class="weui-search-bar__cancel-btn" @click="cancelSearch">取消</a>
  </div>
</template>

<script>
export default {
    name: 'SearchBar',
    props: {
        placeholder: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            searching: false,
        };
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
        },
        focusInput() {
            this.searching = true;
            this.$refs.input.focus();
        },
        clearInput() {
            this.updateValue(null);
            this.$refs.input.focus();
        },
        cancelSearch() {
            this.updateValue(null);
            this.searching = false;
            this.$refs.input.blur();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/search-bar/Index.vue